define([
  'app/control/uploader',
  'app/modules/language',
  'app/modules/local_storage',
  'app/modules/forms',
  'app/modules/employmentHistory',
  'app/modules/utilities',
  'app/modules/user',
], (Uploader, Language, LocalStorage, Forms, EmploymentHistory, Util, User) => {
  const Preferences = function () {};

  Preferences.prototype.actionNew = function () {
    LocalStorage.loadForm(
      'user',
      $('.new-preference-form')
        .attr('action')
        .split('/')[1],
    );
    new Uploader($('#user_photo'), { type: 'image' });
    new Uploader($('#user_resume'), { type: 'file' });

    $('.add-language').on('click', (e) => {
      e.preventDefault();
      Language.add(null, 'user');
    });

    $('.languages-list').on('click', '.remove-language', function (e) {
      e.preventDefault();
      Language.remove($(this));
    });

    $('.new-preference-form').on('submit', function (e) {
      e.preventDefault();
      Forms.submitWithFiles($(this), 'user_');
    });

    $('#user_email').on('input', function () {
      if (Util.validateEmail($(this).val())) Forms.checkEmailField($(this));
    });

    $('.modal#sign-in-modal form#new_user').on('submit', (e) => {
      e.preventDefault();
      e.stopPropagation();
      User.signIn($(e.currentTarget), 'user_');
    });

    Forms.bindSharedControls();

    new EmploymentHistory({
      resourceName: 'user',
    });
  };

  Preferences.prototype.actionCreate = function () {};

  return Preferences;
});
